import { useTranslation } from "react-i18next"
import { Alert, Heading, Text } from "@oysterhr/ui"
import { SepaMethodSelection } from "./components/SepaMethodSelection"
import ConnectPaymentMethodLayout from "../../../layouts/ConnectPaymentMethodLayout"

const SepaMethodSelectionPage = () => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow", {
    keyPrefix: "methodSelection",
  })

  return (
    <ConnectPaymentMethodLayout title={t("title")}>
      <main className="w-full max-w-screen-md rounded-lg border-2 border-gray-200 bg-white p-8">
        <div className="mb-6 text-left">
          <Heading size="lg">{t("sepaHeader")}</Heading>
          <Text size="medium" className="mt-4">
            {t("sepaContent")}
          </Text>
          <Alert className="mt-2" variation="info">
            <Alert.Icon />
            <Alert.Content>{t("alert")}</Alert.Content>
          </Alert>
        </div>

        <SepaMethodSelection />
      </main>
    </ConnectPaymentMethodLayout>
  )
}

export default SepaMethodSelectionPage
